import { config } from "../config";
import axios from "axios";

import { userService } from "./UserService";

class TelemetryService {
    async getRtuCallIns(rtuId) {
        const apiUrl = config.getApiUrl("telemetry");
        const accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${apiUrl}/rtu/${rtuId}/measurements`, {
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "application/json",
                },
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getEdgeCallIns(edgeDeviceId, type) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(
                `${config.getApiUrl("telemetry")}/edge_devices/${edgeDeviceId}/edge_messages`,
                {
                    headers: { Authorization: accessToken },
                    params: { limit: 10, type: type },
                }
            );
            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getDeviceHealth(type, status, lastReportDetails) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/edge_devices/device_health`, {
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "application/json",
                },
                params: {
                    type: type,
                    status: status,
                    lastReportDetails: lastReportDetails,
                },
            });
            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getEdgeMessages(
        deviceId,
        type,
        withPoints,
        startDateTime,
        endDateTime,
        limit = 1,
        getKeysFromS3,
        fetchFromS3,
        dataBody
    ) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(
                `${config.getApiUrl("telemetry")}/edge-messages/${deviceId}?limit=${limit}`,
                {
                    headers: { Authorization: accessToken },
                    params: {
                        type: type,
                        withPoints: withPoints,
                        startDateTime: startDateTime,
                        endDateTime: endDateTime,
                        getKeysFromS3: getKeysFromS3,
                        fetchFromS3: fetchFromS3,
                        dataBody: dataBody,
                    },
                }
            );

            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getAllEdgeMessages(type) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/edge-messages`, {
                headers: { Authorization: accessToken },
                params: { type: type },
            });

            let url = result.data;
            let response = await fetch(url);
            let data = await response.json();

            return data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getAllHexAsciiMessages() {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/rtu/measurements`, {
                headers: { Authorization: accessToken },
            });

            let url = result.data;
            let response = await fetch(url);
            let data = await response.json();

            return data[0];
        } catch (error) {
            console.log("error", error);
        }
    }

    async getAllEdgeConfigs(type) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/edgeConfigs`, {
                headers: { Authorization: accessToken },
                params: { type: type },
            });

            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getAllBurnConfigs(params) {
        let accessToken = userService.getAuthToken();
        const { page, perPage } = params.pagination;
        const offset = (page - 1) * perPage;
        const { edge_device_id, serial_no } = params.filter;

        let urlString = `${config.getApiUrl("telemetry")}/burnConfigs?limit=${perPage}&offset=${offset}`;
        if (edge_device_id) {
            urlString = urlString + `&edge_device_id=${edge_device_id}`;
        }
        if (serial_no) {
            urlString = urlString + `&serial_no=${serial_no}`;
        }

        try {
            const result = await axios.get(urlString, {
                headers: { Authorization: accessToken },
            });

            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getEdgeConfig(id) {
        const accessToken = userService.getAuthToken();

        return await axios.get(`${config.getApiUrl("telemetry")}/edgeConfigs/${id}`, {
            headers: { Authorization: accessToken },
            "Content-Type": "application/json",
        });
    }

    async getBurnConfig(id) {
        const accessToken = userService.getAuthToken();

        return await axios.get(`${config.getApiUrl("telemetry")}/burnConfigs/${id}`, {
            headers: { Authorization: accessToken },
        });
    }

    async deleteBurnConfig(id) {
        console.log("TODO: implement deletion");
        return;
    }

    async saveEdgeConfig(serialNo, device_config) {
        const apiUrl = config.getApiUrl("telemetry");
        const accessToken = userService.getAuthToken();

        return await axios.put(
            `${apiUrl}/edgeConfigs/${serialNo}`,
            { device_config },
            {
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "application/json",
                },
            }
        );
    }

    async saveBurnConfig(deviceId, newData) {
        const apiUrl = config.getApiUrl("telemetry");
        const accessToken = userService.getAuthToken();

        return await axios.put(
            `${apiUrl}/saveBurnConfig/${deviceId}`,
            { newData },
            {
                headers: {
                    Authorization: accessToken,
                },
            }
        );
    }

    async getOutageNote(id) {
        const apiUrl = config.getApiUrl("telemetry");
        const accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${apiUrl}/device_health_note/${id}`, {
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "application/json",
                },
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async upsertOutageNote(id, note) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.post(`${config.getApiUrl("telemetry")}/device_health_note/${id}`, {
                params: { note: note },
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "text/plain",
                },
            });

            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getDeviceStatusHistory(id, dttm) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/device_status_history/${id}`, {
                params: { dttm: dttm },
                headers: { Authorization: accessToken },
                "Content-Type": "application/json",
            });

            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async upsertDeviceStatusHistory(id, dttm, note) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.post(`${config.getApiUrl("telemetry")}/device_status_history/${id}`, {
                params: { dttm: dttm, note: note },
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "text/plain",
                },
            });

            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getOfflineDevices(type) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/offline_devices`, {
                headers: { Authorization: accessToken },
                params: { type: type },
            });

            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getDeviceUptimeHistory(type, startDate, endDate) {
        let accessToken = userService.getAuthToken();

        try {
            let url = "/device_uptime_history";

            const path = `${config.getApiUrl("telemetry")}` + url;
            const result = await axios.get(path, {
                headers: { Authorization: accessToken },
                params: { type: type, startDate: startDate, endDate: endDate },
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getDeviceVisibilityHistory(type, startDate, endDate) {
        let accessToken = userService.getAuthToken();

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/device_visibility_history`, {
                headers: { Authorization: accessToken },
                params: {
                    type: type,
                    startDate: startDate,
                    endDate: endDate,
                },
            });
            return result.data;
        } catch (e) {
            console.log("error", e);
        }
    }

    /**
     *
     * generic telemetry GET
     *
     * @param {string} url
     */
    async get(url) {
        let accessToken = userService.getAuthToken();

        console.log(`begin ${url}`);

        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}${url}`, {
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "application/json",
                },
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getSiteGroupIds(edgeDeviceId) {
        let accessToken = userService.getAuthToken();
        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/site_groups/${edgeDeviceId}`, {
                headers: { Authorization: accessToken },
            });
            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getBurnStatus(id, startDateTime, endDateTime) {
        let accessToken = userService.getAuthToken();
        try {
            const result = await axios.get(`${config.getApiUrl("telemetry")}/burn_status/${id}`, {
                headers: { Authorization: accessToken },
                params: {
                    startDateTime: startDateTime,
                    endDateTime: endDateTime,
                },
            });
            return result;
        } catch (error) {
            console.log("error", error);
        }
    }
}

export const telemetryService = new TelemetryService();
